import { useTranslation } from 'react-i18next'

import { GalaxyButton } from '@shared'

import styles from './FailedRewardScreen.module.scss'

type Props = {
  amount: number
  onDonate: () => void
}

export const FailedRewardScreen = ({ amount, onDonate }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
      <p className={styles.subtitle}>{t('rewards.notAllConditionsMet')}</p>

      <div className={styles.amount}>{`${amount} $NOT`}</div>

      <p className={styles.description}>{t('rewards.balanceTransferred')}</p>
      <div className={styles.bottomContent}>
        <GalaxyButton
          className={styles.button}
          withGlow={false}
          onClick={onDonate}
        >
          {t('rewards.donateTo2ndSeason')}
        </GalaxyButton>
        <span className={styles.terms}>
          {t('rewards.terms')}
        </span>
      </div>
    </div>
  )
}
